import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { initSmoothScroll } from '../utils/smoothScroll';
import { fundraisingData } from '../data/mock';
import { statsApi, fundraisingApi } from '../services/api';

import Header from '../components/Header';
import Hero from '../components/Hero';
import AboutSection from '../components/AboutSection';
import DesignSection from '../components/DesignSection';
import ProjectSiteSection from '../components/ProjectSiteSection';
import ManifestoSection from '../components/ManifestoSection';
import ImpactSection from '../components/ImpactSection';
import BenefitsSection from '../components/BenefitsSection';
import GallerySection from '../components/GallerySection';
import WallOfDua from '../components/WallOfDua';
import ShareSection from '../components/ShareSection';
import FAQSection from '../components/FAQSection';
import Footer from '../components/Footer';
import DonationModal from '../components/DonationModal';

function LandingPage() {
  const [isDonationModalOpen, setIsDonationModalOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  // Live fundraising stats (fallback to mock defaults)
  const [liveStats, setLiveStats] = useState({
    goal: fundraisingData.goal,
    current: fundraisingData.current,
    donorsCount: fundraisingData.donorsCount,
    currentPhaseGoal: fundraisingData.currentPhaseGoal,
  });

  useEffect(() => {
    const lenis = initSmoothScroll();

    // Fetch live fundraising stats
    fundraisingApi.get()
      .then((data) => setLiveStats(data))
      .catch(() => {});

    // Register visit once per session
    if (!sessionStorage.getItem('kdu_visit_registered')) {
      statsApi.registerVisit()
        .then(() => sessionStorage.setItem('kdu_visit_registered', 'true'))
        .catch(() => {});
    }

    setTimeout(() => setIsLoading(false), 1000);

    return () => {
      if (lenis) lenis.destroy();
    };
  }, []);

  if (isLoading) {
    return (
      <div className="fixed inset-0 bg-gradient-to-br from-purple-950 via-purple-900 to-indigo-950 flex items-center justify-center z-50">
        <motion.div
          initial={{ opacity: 0, scale: 0.5 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.5 }}
          className="text-center"
        >
          <motion.div
            animate={{ rotate: 360 }}
            transition={{ duration: 2, repeat: Infinity, ease: 'linear' }}
            className="w-20 h-20 border-4 border-purple-300 border-t-white rounded-full mx-auto mb-6"
          />
          <p className="text-white text-xl font-semibold">Memuatkan...</p>
        </motion.div>
      </div>
    );
  }

  // Merge live stats into the data object passed to Hero
  const heroData = { ...fundraisingData, ...liveStats };

  return (
    <div className="App">
      <Header onDonateClick={() => setIsDonationModalOpen(true)} />

      <Hero data={heroData} onDonateClick={() => setIsDonationModalOpen(true)} />

      <div id="about">
        <AboutSection schoolInfo={fundraisingData.schoolInfo} />
      </div>

      <div id="design">
        <DesignSection images={fundraisingData.schoolImages} />
      </div>

      <div id="site">
        <ProjectSiteSection photos={fundraisingData.projectSite} />
      </div>

      <ManifestoSection />

      <div id="impact">
        <ImpactSection impacts={fundraisingData.impact} />
      </div>

      <div id="benefits">
        <BenefitsSection benefits={fundraisingData.benefits} />
      </div>

      <div id="gallery">
        <GallerySection images={fundraisingData.schoolImages} />
      </div>

      <div id="dua">
        <WallOfDua />
      </div>

      <div id="share">
        <ShareSection />
      </div>

      <div id="faq">
        <FAQSection faqs={fundraisingData.faqs} />
      </div>

      <Footer />

      <DonationModal
        isOpen={isDonationModalOpen}
        onClose={() => setIsDonationModalOpen(false)}
        paymentInfo={fundraisingData.paymentInfo}
      />
    </div>
  );
}

export default LandingPage;
